import { render, staticRenderFns } from "./SalaAtendimento.vue?vue&type=template&id=af6bf3e2&scoped=true&"
import script from "./SalaAtendimento.vue?vue&type=script&lang=js&"
export * from "./SalaAtendimento.vue?vue&type=script&lang=js&"
import style0 from "./SalaAtendimento.vue?vue&type=style&index=0&id=af6bf3e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6bf3e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
